import React from 'react';
import './main.less';

import { Link } from 'react-router';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import { namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import LangSwitch from '../../../shared/lang/switch';
import InputField from '../../../shared/form-elements/input';

function Editor({ intl, lang, languages, error, ...props }) {
	return (
		<div className='form-container'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('create/edit article tag')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form onSubmit={props.handleSubmit}>
					<LangSwitch
						langs={languages}
						onChangeLang={props.onChangeLang}
					/>
					<div className='blog-article-tag-editor'>
						<Field
							name={`name.${lang}`}
							component={InputField}
							placeholder={intl('Article tag name')}
						/>
					</div>
					<div className='banners-buttons'>
						<button className='ui-btn ui-btn-primary'>
							{intl('Save')}
						</button>
						<Link
							className='ui-btn ui-btn-cancel'
							to='/blog/article-tags'
						>
							{intl('Cancel')}
						</Link>
					</div>
					{error && (
						<div className='banners-error'>
							{intl(error)}
						</div>
					)}
				</form>
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		lang: selectors.select(state, 'language'),
		// -----------------------------------------
		languages: selectors.getTabLangs(state)
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(Editor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article-tag/editor/main.js